import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import {IDatosContrato} from '../../../../app/pages/minutas/minutaFood/minutaDTO'
import {setLStorage} from 'global.d'
import {useLocation} from 'react-router-dom'

export function MenuInner() {
  const location = useLocation()
  const isMinutaFood: boolean = location.pathname === '/minutas/minutaFood'
  const info = useSelector<RootState>(({contract}) => contract.info, shallowEqual)
  const infoData: IDatosContrato | any = useSelector<RootState>(
    ({contract}) => contract.infoData,
    shallowEqual
  )
  const infoPlantilla: IDatosContrato | any = useSelector<RootState>(
    ({contract}) => contract.infoPlantilla,
    shallowEqual
  )
  let data = (
    <>
      {/* Indicadores menú */}
      {/* <div className='border border-gray-300 border-dashed rounded min-w-125px my-1 px-4 me-6'>
        <div className='fw-bold fs-6 text-gray-400 text-center'>Alerta</div>
        <div className='d-flex align-items-center'>
          <KTSVG
            path='/media/icons/duotune/arrows/arr066.svg'
            className='svg-icon-3 svg-icon-success me-2 bc-success'
          />
          <div className='fs-2 fw-bolder text-warning'>100</div>
        </div>
      </div> */}

      {/* <div className='border border-gray-300 border-dashed rounded min-w-125px my-1 px-4 me-6'>
        <div className='fw-bold fs-6 text-gray-400 text-center'>Urgente</div>
        <div className='d-flex align-items-center'>
          <KTSVG
            path='/media/icons/duotune/arrows/arr066.svg'
            className='svg-icon-3 svg-icon-success me-2 bc-success'
          />
          <div className='fs-2 fw-bolder text-danger'>250</div>
        </div>
      </div> */}
      {/* <div className='border border-gray-300 border-dashed rounded min-w-125px my-1 px-4 me-6'>
        <div className='fw-bold fs-6 text-gray-400 text-center'>Info</div>
        <div className='d-flex align-items-center'>
          <KTSVG
            path='/media/icons/duotune/arrows/arr066.svg'
            className='svg-icon-3 svg-icon-success me-2 bc-success'
          />
          <div className='fs-2 fw-bolder text-success'>90</div>
        </div>
      </div> */}
    </>
  )
  if (info && infoData !== undefined) {
    const {cli_nombre, cli_codigo, reg_nombre, reg_codigo, ser_nombre, costo_planificado} = infoData
    data = (
      <>
        {info && infoData !== undefined && (
          <>
            <div className='input-group'>
              <div className='container container-position'>
                <div className='row item-nav'>
                  <div className='col col-nav'>
                    {cli_nombre && cli_codigo && (
                      <div className='item-info item-i-nav'>
                        <label htmlFor=''>C. Costo: </label>
                        <label htmlFor=''>
                          {cli_nombre} - {cli_codigo}
                        </label>
                        {/* <label htmlFor="">Hosp. Naval Almte Adriazola Th - 29440</label> */}
                      </div>
                    )}
                    {reg_nombre && reg_codigo && (
                      <div className='item-info item-i-nav'>
                        <label htmlFor=''>Régimen: </label>
                        {/* <label htmlFor=''> Normal Dotación Naval Talcahuano - 11240</label> */}
                        <label htmlFor=''>
                          {reg_nombre} - {reg_codigo}
                        </label>
                      </div>
                    )}
                    {ser_nombre && (
                      <div className='item-info item-i-nav'>
                        <label htmlFor=''>Servicio: </label>
                        {/* <label htmlFor=''> Almuerzo (5)</label> */}
                        <label htmlFor=''>{ser_nombre}</label>
                      </div>
                    )}
                  </div>
                  <div className='col col-nav'>
                    {costo_planificado && (
                      <div className='item-info item-i-nav'>
                        <label htmlFor=''>Costo Bandeja Planificado: </label>
                        <label htmlFor=''>{costo_planificado}</label>
                        {/* <label htmlFor=''> 1.557</label> */}
                      </div>
                    )}

                    {costo_planificado && (
                      <div className='item-info item-i-nav'>
                        <label htmlFor=''>Costo bandeja Ajustado: </label>
                        <label htmlFor=''>{costo_planificado}</label>
                        {/* <label htmlFor=''> 1.770</label> */}
                      </div>
                    )}
                  </div>
                  <div className='col col-nav'>
                    {costo_planificado && (
                      <div className='item-info item-i-nav'>
                        <label htmlFor=''>Alza / baja Costo Bandeja Unit: </label>
                        <label htmlFor=''>{costo_planificado}</label>
                        {/* <label htmlFor=''> 213</label> */}
                      </div>
                    )}
                    {costo_planificado && (
                      <div className='item-info item-i-nav'>
                        <label htmlFor=''>Incremento / Reducción Costo Total: </label>
                        <label htmlFor=''>{costo_planificado}</label>
                        {/* <label htmlFor=''> 122.596</label> */}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </>
    )
  }

  if (info && infoPlantilla !== undefined) {
    const {
      ceco,
      cli_nombre,
      codServicio,
      id,
      plantilla,
      reg_codigo,
      regimen,
      servicio,
      tipo_frecuencia,
      zon_nombre,
      costo,
      Costo_bandeja_target,
    } = infoPlantilla
    if (costo) {
      setLStorage('costoInicial', costo)
    }
    data = (
      <>
        {info && infoPlantilla !== undefined && isMinutaFood && (
          <>
            <div className='input-group ctn-info-menu'>
              <div className='container container-position'>
                <div className='row item-nav'>
                  <div className='col col-nav'>
                    {ceco && (
                      <div className='item-info item-i-nav'>
                        <label htmlFor=''>CECO: </label>
                        <label htmlFor='' id='text-ceco'>
                          {' '}
                          {ceco} - {cli_nombre}
                        </label>
                        {/* <label htmlFor="">Hosp. Naval Almte Adriazola Th - 29440</label> */}
                      </div>
                    )}
                    {servicio && (
                      <div className='item-info item-i-nav'>
                        <label htmlFor=''>Servicio: </label>
                        {/* <label htmlFor=''> Almuerzo (5)</label> */}
                        <label htmlFor='' id='text-servicio'>
                          {' '}
                          {servicio}
                        </label>
                      </div>
                    )}
                  </div>
                  <div className='col col-nav'>
                    {regimen && (
                      <div className='item-info item-i-nav'>
                        <label htmlFor='' className='mr-1'>
                          Régimen:{' '}
                        </label>
                        {/* <label htmlFor=''> Normal Dotación Naval Talcahuano - 11240</label> */}
                        <label htmlFor='' id='text-rgimen'>
                          {' '}
                          {regimen}
                        </label>
                      </div>
                    )}
                    {id && (
                      <div className='item-info item-i-nav'>
                        <label htmlFor=''>Contrato: </label>
                        <label htmlFor='' id='text-contrato'>
                          {' '}
                          {id}
                        </label>
                        {/* <label htmlFor=''> 1.557</label> */}
                      </div>
                    )}
                    {costo && (
                      <div className='item-info item-i-nav'>
                        <label htmlFor=''>Costo: </label>
                        {/* <label htmlFor='' id>  {' '}{costo}</label> */}
                        <label htmlFor='' id='costoProm'></label>
                        {/* <label htmlFor=''> 1.557</label> */}
                      </div>
                    )}
                  </div>
                  <div className='col col-nav'>
                    {Costo_bandeja_target && (
                      <div className='item-info item-i-nav'>
                        <label htmlFor=''>Costo Bandeja Objetivo: </label>
                        {/* <label htmlFor='' id>  {' '}{costo}</label> */}
                        <label htmlFor='' id='costoBandeja'>
                          {Costo_bandeja_target}
                        </label>
                        {/* <label htmlFor=''> 1.557</label> */}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </>
    )
  }

  return data
}
